export default __webpack_public_path__ + "static/media/whiteCloseIcon.4c72375a.svg";